import React from 'react'
import DOMPurify from 'isomorphic-dompurify'

interface SafeHTMLProps {
  html: string
  className?: string
  as?: 'div' | 'span' | 'p' | 'code'
  config?: DOMPurify.Config
}

export default function SafeHTML({ html, className, as = 'span', config }: SafeHTMLProps) {
  const sanitizedHTML = DOMPurify.sanitize(html, config)
  const Component = as

  return <Component className={className} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
}
